import {splitLocale} from '~/utils/tools';

class Message {
  id;

  body;

  color;

  tags = [];

  messageTime;

  feature;

  linkedAppId;

  linkedMenuCode;

  linkedStates;

  zoneOffset;

  ring;

  actionName;

  updateFromJson(json) {
    this.id = json.id;
    this.appId = json.appId;
    if (typeof json.body === 'string') {
      this.body = json.body;
    } else {
      this.body = splitLocale(json.body);
    }
    this.color = json.color;
    this.tags = (json.tags || []).map((t) => {
      if (typeof t === 'string') {
        return t;
      }
      return splitLocale(t);
    });
    this.messageTime = json.messageTime;
    if (typeof json.feature === 'string') {
      this.feature = json.feature;
    } else {
      this.feature = splitLocale(json.feature);
    }
    this.linkedAppId = json.linkedAppId;
    this.linkedMenuCode = json.linkedMenuCode;
    this.linkedStates = json.linkedStates;
    this.zoneOffset = json.zoneOffset;
    this.ring = json.ring;
    if (typeof json.actionName === 'string') {
      this.actionName = json.actionName;
    } else if (json.actionName && json.actionName.default !== '') {
      this.actionName = splitLocale(json.actionName);
    }
  }
}
export default Message;
